import React from 'react';
import classNames from 'classnames';

import * as styles from './WidthContainer.module.scss';
import { WidthContainerProps } from './WidthContainerProps';

export const WidthContainer = ({
	children,
	className = '',
	maxWidth = 1300,
}: WidthContainerProps): JSX.Element => {
	return (
		<div style={{ maxWidth }} className={classNames(styles.root, className)}>
			{children}
		</div>
	);
};
